import FormNavBar from '../../../components/FormNavBar';
import { FormContent } from './FormContent';

type RequestFormViewProps = {
  draftId: string;
};
export const RequestFormView = ({ draftId }: RequestFormViewProps) => {
  return (
    <div style={{ position: 'relative' }}>
      <FormNavBar />
      <FormContent draftId={draftId} />
    </div>
  );
};
